





















































































import { Component, Vue, Watch } from "vue-property-decorator";
import "vuesax/dist/vuesax.css";
import "./sidebar.css";
import SidebarItem from "./sidebar-item.vue";
import { RoutesList } from "@/router";
import { Route, RouteConfig } from "vue-router";
import { vsButton, vsSideBar, vsIcon, vsDivider, vsSpacer } from "vuesax";
import Helpers from "../../../helpers/helper";
import * as signalR from "@aspnet/signalr";
import UserService from "@/services/user.service";

import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import User from "../../../models/security/user.model";
import store from "@/store";
import NationalInterest from '@/modules/nationalInterest/nationalInterest.vue';

Vue.use(vsButton);
Vue.use(vsIcon);
Vue.use(vsDivider);
Vue.use(vsSpacer);
Vue.use(vsSideBar);
@Component({
  components: { SidebarItem }
})
export default class Sidebar extends Vue {
  isActive = true;
  menuItems = RoutesList.getRoutes();
  connection: any = null;
  isExpanded: boolean = false;
  userId: number;
  display = true;
  get isMobile() {
    return this.$store.state.isMobile;
  }
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    this.$store.state.sidebarActive = false;
  }
  get user() {
    return this.$store.state.user;
  }
 get nationalInterest() {
    return this.$store.state.isNationalInterest;
  }

  get showSidebar() {
    return this.$store.state.showSidebar;
  }

  get showPendingEvaluations() {
    return this.$store.state.showPendingEvaluations;
  }

  @Watch("showSidebar")
  onshowSidebar() {
    if (this.showSidebar) {
      this.display = true;
    } else {
      setTimeout(() => {
        this.display = false;
      }, 200);
    }
  }

  created() {
    this.buildSignalRConnection();
    this.registerSignalRInterceptor();
  }
  doScroll() {
    $("#app").scrollTop(200);
  }

  mounted() {
    this.$store.dispatch("getPendingEvaluations", this.user.id);
        this.$store.dispatch("getAnnoucementNationalInterest");

    var burger = document.querySelector(".burger") as any;
    var menu = document.querySelector("#" + burger.dataset.target) as any;
    burger.addEventListener("click", function() {
      burger.classList.toggle("is-active");
      menu.classList.toggle("is-active");
    });
  }

  buildSignalRConnection() {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_BASE_API_URL + "hub")
      .configureLogging(signalR.LogLevel.Information)
      .build();
  }
  registerSignalRInterceptor() {
    this.connection.start().catch((err: any) => {
      // document.write("signalR: " + err);
    });
    this.connection.on("refreshUser", this.setUpdateUserInStorage);

    this.connection.onclose(async () => {
      this.buildSignalRConnection();
      await this.registerSignalRInterceptor();
    });
  }

  setUpdateUserInStorage(userIds: any) {
    
    if (userIds.length) {
      for (let i = 0; i < userIds.length; i++) {
        const userId = userIds[i];
        if (this.user.id == userId) {
          var userService = new UserService();
          userService.getUserWithPermisions(userId).then(x => {
            localStorage.setItem("user", JSON.stringify(x));
            store.commit("set_user", x);
          });
        }
      }
    } else {
      this.userId = userIds;
      if (this.user.id == this.userId) {
        var userService = new UserService();
        userService.getUserWithPermisions(this.userId).then(x => {
          localStorage.setItem("user", JSON.stringify(x));
          store.commit("set_user", x);
        });
      }
    }
  }
  goTo(url) {
    if (!url.includes("/historico")) this.$store.state.recordHistory = [];
    if (url) this.$router.push(url);
  }
  showItem(item: any) {
    if (!this.user || this.user.disabled) return false;

     if (item.meta && item.meta.isInvestigator && item.meta.isNationalInteres && this.nationalInterest) {
      return this.nationalInterest;
    }

    if (item.meta && item.meta.isInvestigator ) {
      if(item.meta.isNationalInteres){
        return false;
      }
      return this.user.isInvestigator;
    }

    if (item.meta && item.meta.isReportEvaluator) {
      return this.user.isReportEvaluator;
    }

    if (item.meta && item.meta.isEvaluator) {
      if (this.user.isEvaluator && !this.showPendingEvaluations)
        return this.user.showPendingEvaluations;
      return this.user.isEvaluator;
    }

    if (item.meta && item.meta.isAdminOrCollaborator) {
      return this.user.isCollaborator || this.user.isAdminCenter;
    }

    if (item.meta && item.meta.isAdminCenter) {
      return this.user.isAdminCenter;
    }

    return (
      this.user.isAdmin ||
      !item.meta ||
      !item.meta.permissionValue ||
      (this.user.permissions &&
        this.user.permissions.some(
          (x: any) => x.permissionValue == item.meta.permissionValue
        ))
    );
  }
}
